// import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import { AuthMachineContext } from "@/store/auth";
import { useState } from "react";
import { SupportModal } from "../SupportModal/SupportModal";
// import { QuestionMarkIcon } from "@radix-ui/react-icons";
import { SimpleTooltip } from "../Tooltip/SimpleTooltip";

export const SupportWidget = () => {
  const isLoggedIn = AuthMachineContext.useSelector((state) => state.context.isLoggedIn);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isLoggedIn) {
    return null;
  }

  return null;
  return (
    <>
      <SupportModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      />
      <div className="_-translate-y-[calc(100%+15px)] fixed bottom-[15px] right-[15px] z-50 overflow-hidden rounded-full max-lg:hidden">
        <SimpleTooltip
          id="support"
          content={
            <>
              Need help?
              <br />
              Click here to submit a support ticket
            </>
          }
        >
          <button
            type="button"
            onClick={() => {
              setIsModalOpen(true);
            }}
            className="flex size-[56px] flex-row bg-black"
          >
            <div className="font-base animated-background flex flex-1 flex-row items-center justify-center gap-2 rounded-full border border-gray-light-500 bg-gradient-to-r from-white to-gray-light-700 text-xs font-medium text-black shadow-lg transition hover:!from-white hover:!to-white hover:text-black dark:border-gray-dark-1200 dark:from-black dark:to-[rgba(255,255,255,0.15)] dark:text-gray dark:hover:!from-white dark:hover:!to-white dark:hover:text-black">
              Help Center
              {/* <QuestionIcon className="size-[26px]" /> */}
              {/* <ChatBubbleLeftEllipsisIcon className="size-[30px]" /> */}
            </div>
          </button>
        </SimpleTooltip>
      </div>
    </>
  );
};
